import React from "react"
import { useTranslation } from "react-i18next"

export default function RenderTranslatedText({i8nKey}){
    const {t}=useTranslation()
    return <span dangerouslySetInnerHTML={{__html:t(i8nKey)}}/>
}